// extracted by mini-css-extract-plugin
export default {"card":"Popular_card__aIDjt","tags":"Popular_tags__OMLjl"};